import { Identity, Team } from "@amzn/ask-legal-domain";
import { TokenGroupProps } from "@amzn/awsui-components-react";
import { Builder } from "builder-pattern";

export namespace EntityPermissionPolarisFactory {
    export namespace TokenGroup {
        /** @deprecated Use toTeamTokens instead */
        export function toTokens(teams: Team[]) {
            return toTeamTokens(teams);
        }

        export function toTeamTokens(teams: Team[]) {
            return teams.map((t) =>
                Builder<TokenGroupProps.Item>()
                    .label(t.teamName)
                    .description(t.teamId)
                    .build()
            );
        }

        export function toUserTokens(users: Identity[]) {
            return users.map((u) =>
                Builder<TokenGroupProps.Item>()
                    .label(u.id)
                    .labelTag(u.name)
                    .description(u.email)
                    .build()
            );
        }
    }
}
